import './style.css';

import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label,
    Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';

import * as usrActions from '../../actions/usrActions';
import { validEmail } from '../../util/validEmail';

const getImage = (image) => {
    if (typeof image === "string") return image;
    if (typeof image === "object") return URL.createObjectURL(image);
    return null;
};

const validImage = (image) => {
    if (!image) return false;
    
    const maxImageSize = 3 * 1024 * 1024;
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    
    if (!image.type || !validTypes.includes(image.type.toLowerCase())) {
        toastr.error('Formato inválido', 'O arquivo selecionado precisa ser do tipo (.JPG, .JPEG, .PNG).');
        return false;
    }
    
    if (image.size > maxImageSize) {
        toastr.error('Tamanho inválido', 'A foto não pode ser maior que 3MB');
        return false;
    }

    return true;
};

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: this.props.auth && this.props.auth.user && this.props.auth.user.email  ? this.props.auth.user.email : '',
            telefone: this.props.auth && this.props.auth.user && this.props.auth.user.phone ? this.props.auth.user.phone : '',
            imagem: this.props.auth && this.props.auth.user && this.props.auth.user.image ? this.props.auth.user.image : '',
        };
    }

    goBack = () => {
        const { options } = this.props;
        if(!!options && !!options.onBack) options.onBack();
    }

    onChangeImage = (imagem) => {
        if (!!imagem && !validImage(imagem)) return false;

        this.setState({ imagem });
    }

    handleChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    onSave = async () => {
        const { auth, options } = this.props;
        const { email, telefone, imagem } = this.state;
        const login = auth.user.login;
        const idnva = !!auth && !!auth.user ? auth.user.idnva : null;
        const clearedPhone = telefone.replace(/[\_]/g, '');

        if (!validEmail(email)) {
            toastr.error('Atenção', 'Digite um e-mail válido.');
            return false;
        }
        
        if (clearedPhone.replace(/[\_]/g, '').length < 14) {
            toastr.error('Atenção', 'O telefone deve ter no mínimo 14 caracteres');
            return false;
        } 
        
        const userData = await this.props.actions.editarusr(login, email, clearedPhone, imagem, idnva );
        
        if(!!options && !!options.onUpdated) options.onUpdated(userData);
    }

    render() {
        const {
            imagem,
            email,
            telefone,
        } = this.state;

        const { options } = this.props;
        
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Form id="formEditarUsr" className="mp-0 w-100">
                        <Row className="justify-content-center">
                            <Col md="6">
                                <Card className="mx-4">
                                    <CardBody className="p-4">
                                        <h1>Alterar dados cadastrais</h1>
                                        <Label className='labelusrImg' id='usrImg'>
                                            {(!!imagem || !!options.imageDefault) && (
                                                <img src={ !!imagem ? getImage(imagem) : options.imageDefault}/>
                                            )}
                                            <Input
                                                className='labelusrImg_input'
                                                type='file'
                                                onChange={event => this.onChangeImage(event.target.files[0])}
                                            />                                            
                                        </Label>
                                        {!!imagem && (
                                            <Button
                                                color="ghost-danger"
                                                size="sm"
                                                onClick={() => this.onChangeImage(null)}
                                            >
                                                <i className="fa fa-trash" />
                                            </Button>
                                        )}
                                        <InputGroup className="mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>@</InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                type="email"
                                                name="email"
                                                id="email"
                                                placeholder="Email"
                                                onChange={this.handleChange}
                                                value={email}
                                            />
                                        </InputGroup>
                                        <InputGroup className="mb-4">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText><i className="icon-lock"></i></InputGroupText>
                                            </InputGroupAddon>                                            
                                            <InputMask
                                                className="form-control"
                                                mask={/^\([1-9]{2}\) 9[2-9]{1}/.test(telefone) ? '(99) 99999-9999' : '(99) 9999-9999'}
                                                type="text"
                                                name="telefone"
                                                id="telefone"
                                                placeholder="Telefone"
                                                onChange={this.handleChange}
                                                value={telefone}
                                            />
                                        </InputGroup>
                                        <Button color="primary-smart" block onClick={this.onSave}>Enviar</Button>
                                        <Button color="secundary-smart" block onClick={this.goBack} >Voltar</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(usrActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
